import {OEFunctionFragmentType} from './function/oe-function-model';

//
export const OENoteFunctionDefinitions = {

    addFragmentMenuTypes: [
        OEFunctionFragmentType.setMediaCenterItem,
        OEFunctionFragmentType.showMedia,
        {type: OEFunctionFragmentType.setNoteText, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyNoteAddState, allowMultipleInstances: true},
        OEFunctionFragmentType.saveNote,
        {type: OEFunctionFragmentType.triggerNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changePresNoteProps, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.applyPresNoteAddState, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.triggerPresNoteAttrSignal, allowMultipleInstances: true},
        {type: OEFunctionFragmentType.changeSlideProps, allowMultipleInstances: true},
        OEFunctionFragmentType.changeActiveSlide,
        {type: OEFunctionFragmentType.setPresTime, allowMultipleInstances: true},
        OEFunctionFragmentType.userNotification,
        OEFunctionFragmentType.applyPreset,
        {type: OEFunctionFragmentType.changeComponent, allowMultipleInstances: true},
        OEFunctionFragmentType.openLink,
        //{type: OEFunctionFragmentType.debugOutput, allowMultipleInstances: true}
    ]
};